import { motion } from "framer-motion";
import { ArrowRight, Mail } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const CTA = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Subtle background decoration */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-50/50 pointer-events-none"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-[2rem] bg-white border border-gray-300/50 shadow-2xl shadow-gray-200/50 p-12 md:p-20 text-center"
        >
          {/* Subtle mesh gradient blob in background */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full overflow-hidden pointer-events-none">
            <div className="absolute top-[-50%] left-[-20%] w-[140%] h-[140%] bg-gradient-to-b from-blue-50/50 via-indigo-50/30 to-transparent rounded-full blur-[80px] opacity-60"></div>
          </div>

          <div className="relative z-10 max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight text-gray-900 leading-tight">
              Ready to scale your{" "}
              <span className="text-blue-600">engineering team?</span>
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed">
              Let us handle the hiring, training, and management so you can
              focus on your product vision.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/contact"
                className="bg-blue-600 text-white font-semibold px-8 py-4 rounded-full shadow-lg shadow-blue-500/20 hover:shadow-xl hover:shadow-blue-500/30 hover:-translate-y-1 transition-all duration-300 flex items-center gap-2 group text-base"
              >
                Schedule a Consultation{" "}
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/contact"
                className="bg-white border border-gray-200 text-gray-700 font-medium px-8 py-4 rounded-full hover:bg-gray-50 hover:border-gray-300 transition-all duration-300 flex items-center gap-2 text-base shadow-sm"
              >
                <Mail className="w-5 h-5 text-gray-500" /> Contact Sales
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
